import React, { useState } from 'react';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from 'recharts';
import { momentFormatDuration } from "utils/helper";
import AnalyticsBarHeader from '../AnalyticsBarHeader/AnalyticsBarHeader';
import { chartLayout } from '../PlottedBarChart/enum';
import "./LiteBarChart.scss";

const LiteBarChart = ({
    data = [],
    width = "100%",
    height = "100%",
    xAxisDataKey = "dateValue",
    bars = [],
    gridStrokeDasharray = "3 3",
    yAxisLabel = "Resolution Time (hours)",
    xAxisLabel = "Date Range",
    isLoading = false,
    overviews,
    skipCompute = false,
    hideModeSelection = false,
    chartTitle = "",
}) => {
    const { HORIZONTAL, VERTICAL } = chartLayout;

    const [chartMode, setChartMode] = useState(
        hideModeSelection ? VERTICAL : HORIZONTAL
    );

    if (isLoading) {
        return (
            <div className='plotted__bar__chart__container'>
                <div className='y-axis graph__label'>{yAxisLabel}</div>
                <div className='plotted__bar__chart loading'>
                    <div className="loading-text">Loading...</div>
                    <ResponsiveContainer width='100%' height='100%'>
                        <BarChart data={[]} width={500} height={300}>
                            <CartesianGrid strokeDasharray={gridStrokeDasharray} strokeOpacity={0.2} />
                            <XAxis axisLine={false} tickLine={false} tick={false} />
                            <YAxis axisLine={false} tickLine={false} tick={false} />
                            <Bar dataKey="dummy" fill="#666" animationDuration={800} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                <div className='x-axis graph__label'>{xAxisLabel}</div>
            </div>
        );
    }

    return (
        <div className="analytics__bar__chart">
               <h3 className='analytics__title'>{chartTitle}</h3>
            {!hideModeSelection && (
                <AnalyticsBarHeader
                    chartMode={chartMode}
                    setChartMode={setChartMode}
                    overviews={overviews}
                    skipCompute={skipCompute}
                    isLoading={isLoading}
                />
            )}
        <div className='plotted__bar__chart__container'>
            <div className='y-axis graph__label'>{yAxisLabel}</div>
            <div className='plotted__bar__chart'>
                <ResponsiveContainer width={width} height={height} isAnimationActive>
                    <BarChart
                        data={data}
                        width={500} height={300}
                        layout={"horizontal"}
                    >
                        <CartesianGrid 
                            strokeDasharray='0.1 0.1'
                            strokeOpacity={0.2}
                            vertical={false}
                            horizontal={true}
                        />
                        <XAxis 
                            dataKey={xAxisDataKey}
                            axisLine={false}
                            tickLine={false}
                        />
                        <YAxis 
                            axisLine={false}
                            tickLine={false}
                        />
                        <Tooltip
                            cursor={{ fill: "transparent" }}
                            wrapperStyle={{ visibility: "visible" }}
                            content={(props) => {
                                const { payload, label } = props;
                                if (!payload || !payload.length) return null;

                                return (
                                    <div className="chart-tooltip d-block">
                                        <p className="label">{label}</p>
                                        {bars.map((bar, index) => {
                                            const value = payload[0]?.payload[bar.value];
                                            return value ? (
                                                <div key={index}>
                                                    <h5 className="mb-1">{bar.label}</h5>
                                                    <h4>{momentFormatDuration(value)}</h4>
                                                </div>
                                            ) : null;
                                        })}
                                    </div>
                                );
                            }}
                        />
                        {bars.map((bar, index) => (
                            <Bar
                                key={index}
                                dataKey={bar.value}
                                stackId="a"
                                fill={bar.color}
                                name={bar.label}
                                barSize={500}
                            />
                        ))}
                    </BarChart>
                </ResponsiveContainer>
            </div>
            <div className='x-axis graph__label'>{xAxisLabel}</div>
        </div>
        </div>
    );
};

export default LiteBarChart;